import {
  SafeTag,
  PendingOffer,
  Alert,
  If,
  Loader
} from '@itau-loans-www/components'
import IconAviso from '@mobi/ds/static/icons/outlined/aviso.svg'

import Layout from '../../layouts/Summary'
import PendingForm from '../components/PendingForm'
import { usePendingFormalization } from './hooks'
import './pending-formalization.scss'

const PendingFormalization = () => {
  const {
    proposal,
    isLoading,
    closeAlert,
    isAlertVisible,
    handleSendProposal,
    initialValuesFromApi,
    submitLoading
  } = usePendingFormalization()

  return (
    <Layout>
      <div className="pending-formalization container">
        <SafeTag />
        <Alert
          isVisible={isAlertVisible}
          paragraph={null}
          icon={<IconAviso />}
          message={`
            <h2>
              Em andamento
            </h2>
            <p>
              formalização não finalizada
            </p>
            `}
          closeAlert={closeAlert}
          variant="error"
        />
        <section className="pending-formalization__content">
          <h1 className="pending-formalization__title">
            Você ainda não formalizou a sua proposta de empréstimo
          </h1>
          <p className="pending-formalization__subtitle">
            Verifique se os seus dados estão corretos e solicite um novo link
            via SMS para seguir com a formalização da sua proposta.
          </p>

          <PendingOffer proposal={proposal} />

          <If
            condition={!isLoading}
            renderIf={
              <PendingForm
                IsFormCompleted
                nextButtonText="Solicitar link"
                initialValuesFromApi={initialValuesFromApi}
                handleSendProposal={handleSendProposal}
                submitLoading={submitLoading}
              />
            }
            renderElse={<Loader visible hasOverlay />}
          />
        </section>
      </div>
    </Layout>
  )
}

export default PendingFormalization
